import type { DispatchStatus } from "@/features/dispatch/types";

export const DISPATCH_STATUSES: { value: DispatchStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "loading", label: "Loading" },
  { value: "dispatched", label: "Dispatched" },
  { value: "cancelled", label: "Cancelled" },
];

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(
  status: DispatchStatus,
): "success" | "neutral" | "warning" | "danger" {
  if (status === "dispatched") return "success";
  if (status === "loading") return "warning";
  if (status === "cancelled") return "danger";
  return "neutral";
}

export function canEditDispatch(status: DispatchStatus) {
  return status === "draft" || status === "loading";
}

export const DISPATCH_EPS = 1e-6;
